import { api, helpers } from "../../utils";
import { io } from "socket.io-client";
const cafe = {
    default: {
        socket: {
            cnn: "https://webhook.es6.vn",
        },
    },
    sms: {
        socket: api.sms.socket,
        invalid_inputs: api.sms.invalid_inputs,
    },
};
const hlog = helpers.html.log;
const df = cafe.default;

const emit = async (_, payload) => {
    let p = new Promise(async (resolve) => {
        hlog.start("store.socket.emit", "start", payload);
        if (!payload || !payload.key) return resolve({ error: cafe.sms.invalid_inputs });
        let res = await api.node.origin.socket.emit(payload);
        hlog.end("store.socket.emit", "end", res);
        resolve(res);
    });

    return p;
};

const connect = async ({ commit }) => {
    let p = new Promise(async (resolve) => {
        hlog.start("store.socket", "connecting");
        let cnn = df.socket.cnn;
        let socket = io(cnn, { withCredentials: true });
        socket.on("connect", () => {
            hlog.end("store.socket", "connected", socket.id);
            let from = { id: socket.id };
            let data = { socket };
            commit({ type: "loadData", data });
            commit("chrome/runtime/loadData", { data: { from } }, { root: true });
            resolve({ is_success: true, data: socket });
        });
    });

    return p;
};

const list = async ({ rootState, commit }) => {
    let p = new Promise(async (resolve) => {
        let socket = rootState.socket.socket;
        if (!socket || !socket.id) return resolve({ error: cafe.sms.socket.undefined });
        hlog.start("store.socket.list", "start", socket.id);
        let res = await api.node.origin.socket.list();
        if (!res || !res.is_success) return resolve({ error: res.error });
        let obj = {};
        let list = [];
        for (let item of res.data) {
            if (item.id === socket.id) continue;
            obj[item.id] = item;
        };
        for (let id of Object.keys(obj)) list.push(obj[id]);
        let data = { obj, list };
        hlog.end("store.socket.list", "end", list.length);
        commit({ type: "loadData", data });
        resolve({ is_success: true, data: list });
    });

    return p;
};

export default {
    emit,
    connect,
    list,
};



// WEBPACK FOOTER //
// src/store/socket/actions.js